import { render, staticRenderFns } from "./ZoneTable.vue?vue&type=template&id=aa2be8da"
import script from "./ZoneTable.vue?vue&type=script&setup=true&lang=js"
export * from "./ZoneTable.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports